import React, { Component } from 'react';
import { Pagination, Tabs, Tab, HelpBlock, DropdownButton, MenuItem, Button, Form, FormControl, FormGroup, InputGroup, ControlLabel, Row, Col, Popover, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import WorkdocStore from '../../stores/WorkdocStore'

var NotificationSystem = require('react-notification-system');
class WorkDocStock extends Component {

  constructor(props) {
    super(props)

    this.state = {loading:false,data:[]}
  }

  componentDidMount() {
    this.loadData()
  }

  loadData() {
    this.setState({loading:true})
    WorkdocStore.loadWorkDocStock(this.props.workNo,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      sum += parseFloat(item.quantity*item.cost_per_unit)
    })
    return sum
  }

  renderRowData() {
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td>{item.description}</td>
              <td className='text-center'>{item.stock_type_text}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(item.quantity*item.cost_per_unit)}</td>
              <td className='text-center'>{item.record_date}</td>
              <td className='text-center'>{item.record_time}</td>
              <td className='text-center'>{item.request_by}</td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th style={{width:'5%'}} className='text-center'>ลำดับ</th>
              <th style={{width:'25%'}} className='text-center'>รายการอะไหล่</th>
              <th style={{width:'10%'}} className='text-center'>ประเภท</th>
              <th style={{width:'5%'}} className='text-center'>จำนวน</th>
              <th style={{width:'10%'}} className='text-center'>ต้นทุนต่อหน่วย</th>
              <th style={{width:'10%'}} className='text-center'>จำนวนเงิน</th>
              <th style={{width:'10%'}} className='text-center'>วันเบิกไปซ่อม</th>
              <th style={{width:'10%'}} className='text-center'>เวลาเบิกไปซ่อม</th>
              <th style={{width:'10%'}} className='text-center'>ผู้ขอเบิก</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={5}></th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary())}</th>
              <th colSpan={3}></th>
            </tr>
          </tfoot>  
        </table>
      </div>
    )
  }

  render() {
    let {loading} = this.state
    return(
        <Box loading={loading}>
          <Box.Header>
            <Box.Title></Box.Title>
            <Box.Tools>
              
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            {this.renderTable()}
          </Box.Body>
        </Box>  
    )   
  }   
}

WorkDocStock.defaultProps = {  

}

export default WorkDocStock;          


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocStock.js